import React, { FunctionComponent, useState } from "react";
import { TextField } from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { strings } from "../../localization/LocalizedStrings";
import { DateView, LocalizationProvider } from "@mui/x-date-pickers";
import "@mui/lab";
import { AdapterDateFns as DateAdapter } from "@mui/x-date-pickers/AdapterDateFns";
import styles from "./styles.module.scss";
import { omit } from "lodash";

export const DatePickerField: FunctionComponent<IDatePickerFieldProps> = ({
  className,
  value,
  onChange,
  format,
  views,
  disabled
}) => {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  return (
    <LocalizationProvider
      localeText={
        strings.datePickerLocale.components.MuiLocalizationProvider.defaultProps.localeText
      }
      dateAdapter={DateAdapter}
      adapterLocale={strings.fnsLocale}
    >
      <MobileDatePicker
        slotProps={{
          actionBar: {
            actions: ["clear"]
          }
        }}
        format={format ?? "d MMMM yyyy"}
        views={views}
        value={value}
        onChange={onChange}
        open={isDatePickerOpen}
        minDate={new Date(strings.minDate)}
        onClose={() => setIsDatePickerOpen(false)}
        closeOnSelect
        slots={{
          textField: params => (
            <TextField
              {...omit(params, "onChange", "onError")}
              className={className}
              placeholder={strings.date_missing}
              variant={"outlined"}
              disabled={disabled}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                borderRadius: "12px !important",
                transition: "0.3s all",
                "&:hover": {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  boxShadow: "0 4px 20px 0 rgba(0, 0, 0, 0.05)"
                },
                height: "40px"
              }}
              onMouseDown={() => setIsDatePickerOpen(true)}
              inputProps={{
                ...params.inputProps,
                className: styles.input,
                style: { paddingTop: 9, paddingBottom: 9, borderRadius: "12px !important" }
              }}
            />
          )
        }}
      />
    </LocalizationProvider>
  );
};

export interface IDatePickerFieldProps {
  className?: string;
  title: string;
  value: Date | null;
  onChange: (newValue: Date | null) => void;
  format?: string;
  views?: DateView[];
  disabled?: boolean;
}
